import errors from "./errors";
import messages from "./messages";
import strings from "./strings";

const translation = {
    errors,
    messages,
    ...strings
};

export default translation;
